module.exports = __webpack_public_path__ + "Groups0001-f8c76652bcd10bf755e1289fd109bd00.png";